<ds-textbox [textboxInput]="textboxConfig" (input)="onChange($event)" twoDigitDecimalNumber
></ds-textbox>